/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Ingredient } from './Ingredient'
import { PharmaceuticalFormStub } from './PharmaceuticalFormStub'
import { RouteOfAdministration } from './RouteOfAdministration'
import { SamText } from './SamText'

export class AmpComponent {
  constructor(json: JSON | any) {
    Object.assign(this as AmpComponent, json)
  }

  from?: number
  to?: number
  ingredients?: Array<Ingredient>
  pharmaceuticalForms?: Array<PharmaceuticalFormStub>
  routeOfAdministrations?: Array<RouteOfAdministration>
  dividable?: string
  scored?: string
  crushable?: AmpComponent.CrushableEnum
  containsAlcohol?: AmpComponent.ContainsAlcoholEnum
  sugarFree?: boolean
  modifiedReleaseType?: number
  specificDrugDevice?: number
  dimensions?: string
  name?: SamText
  note?: SamText
}
export namespace AmpComponent {
  export type CrushableEnum = 'Y' | 'N' | 'X'
  export const CrushableEnum = {
    Y: 'Y' as CrushableEnum,
    N: 'N' as CrushableEnum,
    X: 'X' as CrushableEnum,
  }
  export type ContainsAlcoholEnum = 'Y' | 'N' | 'X'
  export const ContainsAlcoholEnum = {
    Y: 'Y' as ContainsAlcoholEnum,
    N: 'N' as ContainsAlcoholEnum,
    X: 'X' as ContainsAlcoholEnum,
  }
}
